import BMapViewWidget from "../../../widgetsExtend/BmapViewWidget/widget";
import {WidgetType} from "../../../constants/WidgetConstants";

class AtBMapWidget extends BMapViewWidget{
  static getWidgetType(): WidgetType {
    return "AT_B_MAP_WIDGET";
  }
}
export default AtBMapWidget;
